/* MWB Foto-Lightbox (28.09.2026). Markup: snippets/mwb-lightbox.liquid, CSS: assets/mwb-lightbox.css.
   Baut auf Dawns ModalDialog (assets/global.js) auf: Fokusfalle, Scroll-Sperre (body.overflow-hidden),
   Fokus zurueck an den Ausloeser. Esc nimmt zuerst den Zoom zurueck, dann schliesst es.
   Die Uhr steht wie in der Galerie auf der Studio-Buehne; gemessen wird wie im Buehnen-Skript
   von sections/main-product.liquid (gleicher sessionStorage-Schluessel mwbStage:<pfad>),
   damit schon vermessene Fotos sofort richtig stehen. Nicht freigestellte Fotos (kein
   transparenter Rand) erscheinen als normales Foto mit runden Ecken. */
if (!customElements.get('mwb-lightbox')) {
  customElements.define(
    'mwb-lightbox',
    class MwbLightbox extends ModalDialog {
      constructor() {
        super();
        this.ZOOM = 2.5;
        this.FLOOR = 0.78; /* Standlinie bei 78 % der Fensterhoehe, wie der Boden im Hintergrund */
        this.track = this.querySelector('[data-lb-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.mwb-lb__slide'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-lb-thumb]'));
        this.countEl = this.querySelector('[data-lb-count]');
        this.prevB = this.querySelector('[data-lb-prev]');
        this.nextB = this.querySelector('[data-lb-next]');
        this.index = 0;
        this.zs = null;
        this.lastTap = 0;
        this.drag = null;

        var hint = this.querySelector('[data-lb-hint]');
        if (hint) hint.textContent = window.matchMedia('(hover: none)').matches ? hint.dataset.hintTouch : hint.dataset.hintMouse;

        var self = this;
        if (this.prevB) this.prevB.addEventListener('click', function () { self.go(self.index - 1); });
        if (this.nextB) this.nextB.addEventListener('click', function () { self.go(self.index + 1); });
        this.thumbs.forEach(function (t) {
          t.addEventListener('click', function () { self.go(Number(t.dataset.lbThumb)); });
        });

        var st;
        this.track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
            if (i !== self.index) { self.unzoom(); self.setIndex(i); }
          }, 60);
        }, { passive: true });

        this.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
        });

        window.addEventListener('resize', function () {
          if (!self.hasAttribute('open')) return;
          self.unzoom();
          self.layoutAll();
          self.track.scrollTo({ left: self.index * self.track.clientWidth });
        });

        this.slides.forEach(function (slide) { self.bindZoom(slide); });
      }

      reduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      show(opener) {
        super.show(opener);
        var id = opener && opener.getAttribute('data-media-id');
        var i = 0;
        this.slides.forEach(function (s, k) { if (s.dataset.mediaId === id) i = k; });
        /* Aktives Foto und Nachbarn sofort laden, der Rest laedt beim Blaettern (lazy) */
        for (var k = i - 1; k <= i + 1; k++) {
          var s = this.slides[k];
          if (s) s.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
        }
        var self = this;
        this.slides.forEach(function (s) { self.measure(s); });
        this.layoutAll();
        this.go(i, true);

        var img = this.slides[i] && this.slides[i].querySelector('.mwb-lb__img');
        var src = this.galleryImg(opener);
        if (img && src && !this.reduced()) this.fly(img, this.fitRect(src), this.fitRect(img));
        requestAnimationFrame(function () { self.classList.add('is-open'); });
      }

      hide(fromButton) {
        /* ModalDialog ruft hide() ohne Argument bei Esc: im Zoom erst zuruecknehmen */
        if (fromButton === undefined && this.zs) { this.unzoom(); return; }
        if (this.closing || !this.hasAttribute('open')) return;
        this.unzoom();
        var slide = this.slides[this.index];
        var img = slide && slide.querySelector('.mwb-lb__img');
        var src = this.galleryImg(this.openedBy);
        if (img && src && !this.reduced() && this.inView(src)) {
          var toR = this.fitRect(src), fromR = this.fitRect(img);
          img.style.transformOrigin = '50% 50%';
          img.style.transition = 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
          img.style.transform = 'translate(' + (toR.cx - fromR.cx) + 'px,' + (toR.cy - fromR.cy) + 'px) scale(' + (toR.w / fromR.w) + ')';
        }
        this.classList.remove('is-open');
        this.closing = true;
        var self = this;
        setTimeout(function () {
          self.closing = false;
          if (img) { img.style.transition = ''; img.style.transform = ''; }
          ModalDialog.prototype.hide.call(self);
        }, this.reduced() ? 0 : 300);
      }

      /* ── Blaettern ── */
      setIndex(i) {
        this.index = i;
        if (this.countEl) this.countEl.textContent = (i + 1) + ' / ' + this.slides.length;
        if (this.prevB) this.prevB.disabled = i === 0;
        if (this.nextB) this.nextB.disabled = i === this.slides.length - 1;
        this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
        var s = this.slides[i + 1];
        if (s) s.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      }

      go(i, instant) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        this.unzoom();
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant || this.reduced() ? 'auto' : 'smooth' });
        this.setIndex(i);
      }

      /* ── Einflug / Rueckflug (nur transform, kein filter: Safari-Regel) ── */
      galleryImg(opener) {
        var box = opener && opener.closest('.product-media-container');
        return box ? box.querySelector('.product__media > img:not(.mwb-stage__refl)') : null;
      }

      fitRect(img) {
        var r = img.getBoundingClientRect();
        var nr = (img.naturalWidth / img.naturalHeight) || (Number(img.getAttribute('width')) / Number(img.getAttribute('height'))) || 1;
        var w = r.width, h = r.height;
        if (w / h > nr) w = h * nr; else h = w / nr;
        return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: w, h: h };
      }

      inView(el) {
        var r = el.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
      }

      fly(img, fromR, toR) {
        if (!toR.w) return;
        img.style.transformOrigin = '50% 50%';
        img.style.transition = 'none';
        img.style.transform = 'translate(' + (fromR.cx - toR.cx) + 'px,' + (fromR.cy - toR.cy) + 'px) scale(' + (fromR.w / toR.w) + ')';
        void img.offsetWidth;
        img.style.transition = 'transform 0.35s cubic-bezier(0.16, 1, 0.3, 1)';
        img.style.transform = '';
        setTimeout(function () { img.style.transition = ''; }, 360);
      }

      /* ── Messung (wie das Buehnen-Skript) und Platzierung auf der Standlinie ── */
      measure(slide) {
        if (slide._m || slide._measuring || slide.classList.contains('is-media')) return;
        var img = slide.querySelector('.mwb-lb__img');
        if (!img) return;
        var key = 'mwbStage:' + (img.getAttribute('src') || '').split('?')[0];
        var cached = null;
        try { var v = sessionStorage.getItem(key); cached = v ? JSON.parse(v) : null; } catch (e) {}
        if (cached) { slide._m = this.parseM(cached); return; }

        var src = img.getAttribute('src') || '';
        var url = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=160') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160';
        var probe = new Image();
        var self = this;
        slide._measuring = true;
        probe.crossOrigin = 'anonymous';
        probe.onload = function () {
          slide._measuring = false;
          try {
            var w = probe.naturalWidth, h = probe.naturalHeight;
            var c = document.createElement('canvas');
            c.width = w; c.height = h;
            var ctx = c.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(probe, 0, 0);
            var d = ctx.getImageData(0, 0, w, h).data;
            var rowHas = function (y) { for (var x = 0; x < w; x++) { if (d[(y * w + x) * 4 + 3] > 20) return true; } return false; };
            var top = 0, bot = h - 1, left = 0, right = w - 1;
            while (top < h && !rowHas(top)) top++;
            while (bot > top && !rowHas(bot)) bot--;
            if (top >= h) return;
            var colHas = function (x) { for (var y = top; y <= bot; y++) { if (d[(y * w + x) * 4 + 3] > 20) return true; } return false; };
            while (left < w && !colHas(left)) left++;
            while (right > left && !colHas(right)) right--;
            var car = (right - left + 1) / (bot - top + 1);
            var m = {
              pt: (top / h).toFixed(4),
              pb: ((h - 1 - bot) / h).toFixed(4),
              pl: (left / w).toFixed(4),
              pr: ((w - 1 - right) / w).toFixed(4),
              car: car.toFixed(4),
              chn: Math.min(0.535, 0.736 / car).toFixed(4)
            };
            try { sessionStorage.setItem(key, JSON.stringify(m)); } catch (e) {}
            slide._m = self.parseM(m);
            if (self.hasAttribute('open')) self.layout(slide);
          } catch (e) {
            slide._m = { photo: true };
            if (self.hasAttribute('open')) self.layout(slide);
          }
        };
        probe.onerror = function () { slide._measuring = false; slide._m = { photo: true }; };
        probe.src = url;
      }

      parseM(v) {
        var m = { pt: +v.pt, pb: +v.pb, pl: +v.pl, pr: +v.pr, car: +v.car };
        /* Kein leerer Rand ringsum = nicht freigestelltes Foto */
        m.photo = m.pt + m.pb + m.pl + m.pr < 0.004;
        return m;
      }

      layout(slide) {
        if (slide.classList.contains('is-media')) return;
        var img = slide.querySelector('.mwb-lb__img');
        var refl = slide.querySelector('.mwb-lb__refl');
        var sh = slide.querySelector('.mwb-lb__shadow');
        var sr = slide.getBoundingClientRect();
        var W = sr.width, H = sr.height;
        if (!img || !W || !H) return;
        var nr = Number(img.getAttribute('width')) / Number(img.getAttribute('height')) || (img.naturalWidth / img.naturalHeight) || 0.667;
        /* Solange noch nicht gemessen: als Foto zentriert, danach auf die Standlinie */
        var m = slide._m || { photo: true };
        slide.classList.toggle('is-photo', !!m.photo);
        if (m.photo) {
          var pad = W < 750 ? 24 : 160;
          var h = Math.min(H - 24, (W - pad) / nr);
          img.style.height = h + 'px';
          img.style.top = ((H - h) / 2) + 'px';
          img.style.bottom = 'auto';
          img.style.translate = '-50% 0';
          return;
        }
        /* Querformat-Motive (Handgelenk) stehen nicht auf dem Boden: auf dem Handy wurden sie
           durch die Breite so flach, dass sie tief unten auf der Standlinie sassen (Robin 28.09.).
           Darum mittig in den Bildbereich, ohne Spiegelung und Bodenschatten. */
        var wide = m.car > 1.15;
        slide.classList.toggle('is-wide', wide);
        if (wide) {
          var wmh = Math.min(H - 32, (W * (W < 750 ? 0.92 : 0.7)) / m.car);
          var wih = wmh / (1 - m.pt - m.pb);
          var wdx = (m.pr - m.pl) * wih * nr / 2;
          img.style.height = wih + 'px';
          img.style.bottom = 'auto';
          img.style.top = ((H - wmh) / 2 - m.pt * wih) + 'px';
          img.style.translate = 'calc(-50% + ' + wdx + 'px) 0';
          return;
        }
        var floorY = window.innerHeight * this.FLOOR - sr.top;
        var cb = H - floorY;
        var mh = Math.min(floorY - 16, window.innerHeight * 0.56, (W * (W < 750 ? 0.86 : 0.7)) / m.car);
        var ih = mh / (1 - m.pt - m.pb);
        var dx = (m.pr - m.pl) * ih * nr / 2;
        var tr = 'calc(-50% + ' + dx + 'px) 0';
        img.style.top = 'auto';
        img.style.height = ih + 'px';
        img.style.bottom = (cb - m.pb * ih) + 'px';
        img.style.translate = tr;
        if (refl) {
          refl.style.height = ih + 'px';
          refl.style.bottom = (cb - ih * (1 - m.pb)) + 'px';
          refl.style.translate = tr;
        }
        slide.style.setProperty('--lb-pb', m.pb);
        if (sh) {
          sh.style.bottom = cb + 'px';
          sh.style.width = (mh * m.car * 1.06) + 'px';
        }
      }

      layoutAll() {
        var self = this;
        this.slides.forEach(function (s) { self.layout(s); });
      }

      /* ── Zoom: transform-origin folgt Maus bzw. Finger ── */
      zoomAt(slide, cx, cy) {
        var img = slide.querySelector('.mwb-lb__img');
        var r = img.getBoundingClientRect();
        var ox = Math.max(0, Math.min(100, (cx - r.left) / r.width * 100));
        var oy = Math.max(0, Math.min(100, (cy - r.top) / r.height * 100));
        img.style.transition = '';
        img.style.transformOrigin = ox + '% ' + oy + '%';
        img.style.transform = 'scale(' + this.ZOOM + ')';
        slide.classList.add('is-zoomed');
        this.classList.add('is-zoomed');
        this.zs = { slide: slide, img: img, ox: ox, oy: oy };
      }

      unzoom() {
        if (!this.zs) return;
        this.zs.img.style.transform = '';
        this.zs.slide.classList.remove('is-zoomed', 'is-panning');
        this.classList.remove('is-zoomed');
        this.zs = null;
      }

      bindZoom(slide) {
        var img = slide.querySelector('.mwb-lb__img');
        if (!img) return;
        var self = this;
        img.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse') return;
          if (self.zs && self.zs.slide === slide) {
            self.drag = { x: e.clientX, y: e.clientY, ox: self.zs.ox, oy: self.zs.oy, id: e.pointerId, moved: false };
            img.setPointerCapture(e.pointerId);
          }
        });
        img.addEventListener('pointermove', function (e) {
          var zs = self.zs;
          if (!zs || zs.slide !== slide) return;
          if (e.pointerType === 'mouse') {
            var r = slide.getBoundingClientRect();
            zs.ox = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
            zs.oy = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
            img.style.transformOrigin = zs.ox + '% ' + zs.oy + '%';
            return;
          }
          var drag = self.drag;
          if (!drag || drag.id !== e.pointerId) return;
          var r2 = img.getBoundingClientRect();
          var w = r2.width / self.ZOOM, h = r2.height / self.ZOOM;
          var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
          if (Math.abs(dx) + Math.abs(dy) > 4) drag.moved = true;
          slide.classList.add('is-panning');
          zs.ox = Math.max(0, Math.min(100, drag.ox - dx / (self.ZOOM - 1) / w * 100));
          zs.oy = Math.max(0, Math.min(100, drag.oy - dy / (self.ZOOM - 1) / h * 100));
          img.style.transformOrigin = zs.ox + '% ' + zs.oy + '%';
        });
        img.addEventListener('pointerup', function (e) {
          if (e.pointerType === 'mouse') {
            if (e.button !== 0) return;
            if (self.zs && self.zs.slide === slide) self.unzoom();
            else self.zoomAt(slide, e.clientX, e.clientY);
            return;
          }
          slide.classList.remove('is-panning');
          var moved = self.drag && self.drag.moved;
          self.drag = null;
          if (moved) return;
          var now = Date.now();
          if (now - self.lastTap < 300) {
            self.lastTap = 0;
            if (self.zs && self.zs.slide === slide) self.unzoom();
            else self.zoomAt(slide, e.clientX, e.clientY);
          } else {
            self.lastTap = now;
          }
        });
        img.addEventListener('pointercancel', function () {
          self.drag = null;
          slide.classList.remove('is-panning');
        });
      }
    }
  );
}
